import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'gatsby'
import classNames from 'classnames'

import './Header.css'
import links from '@data/links.json'
import MenuIcon from '@components/Common/Icons/16/Menu16'
import CloseIcon from '@components/Common/Icons/16/Close16'
import MobileNav from '@components/Common/MobileNav/MobileNav'
import Button from '@components/Common/Button/Button'
import logo from './xelex-logo--color.svg'

const Header = () => {
  const [navOpen, setNavOpen] = useState(false)
  const ref = useRef(null)

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setNavOpen(false)
    }
  }

  const toggleMobileNav = () => setNavOpen((value) => !value)

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [])

  return (
    <>
      <header className='c-header'>
        <div className='c-header__container'>
          <div className='flex flex-grow'>
            <Link className='block' to={links.home}>
              <img className='c-header__logo' src={logo} alt='Xelex Logo' />
            </Link>
          </div>
          <nav className='hidden items-center md:flex'>
            <Link
              to={links.services}
              className='c-header-nav-link'
              activeClassName='c-header-nav-link--active'
            >
              Services
            </Link>
            <Link
              to={links.useCases}
              className='c-header-nav-link'
              activeClassName='c-header-nav-link--active'
            >
              Use Cases
            </Link>
            <Link
              to={links.login}
              className='c-header-nav-link'
              activeClassName='c-header-nav-link--active'
            >
              Login
            </Link>
            <Button
              className='ml-4 lg:ml-6 self-center'
              label='Get a Demo'
              link={links.demo}
            />
          </nav>
          <div ref={ref}>
            <button
              type='button'
              className='c-nav-button'
              aria-label='Mobile Navigation Menu'
              onClick={toggleMobileNav}
            >
              <MenuIcon
                className={classNames('fill-brand-dark block', {
                  hidden: navOpen
                })}
              />
              <CloseIcon
                className={classNames('fill-brand-dark', {
                  hidden: !navOpen,
                  block: navOpen
                })}
              />
            </button>
            <MobileNav isOpen={navOpen} />
          </div>
        </div>
      </header>
    </>
  )
}

export default Header
